import React from 'react';
import variables from '@ingka/variables/design-tokens';
import styled from 'styled-components';
import useTranslation from '../hooks/useTranslation';
import SearchResults from './SearchResults';
import TMarkUp from './TMarkUp';

const SearchLayout = styled.div`
  margin-bottom: 100px;
  ${`@media (min-width: ${variables.breakpointM}) {
      min-width: 60%;
      margin-bottom: 0;
  }`}
`;

const SearchLayoutTitle = styled.h1.attrs({ as: 'h1', className: 'h1' })`
  margin: 16px 0;
  ${`@media (min-width: ${variables.breakpointM}) {
      margin: 20px 0;
  }`}
`;

const Search = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <SearchLayout>
      <SearchLayoutTitle>
        <TMarkUp value={t('spareParts.spareParts')} />
      </SearchLayoutTitle>
      <SearchResults />
    </SearchLayout>
  );
};

export default Search;
